import Cookies from 'js-cookie';
import { axiosProtected } from '../config';
import { getAppSource, getUserType } from '../helpers';

export const getCovid19Data = async (accountNum) => {
  const data = {
    "accountNumber": accountNum,
    "privateLabelUrl": Cookies.get("privateLabelUrl"),
    "ipAddress": Cookies.get('publicIp'),
    "browser": Cookies.get("browser"),
    "appSource": getAppSource(),
    "userType": getUserType(),
    "userName": "",
  };
  try {
    const response = await axiosProtected.post('/Covid19/GetCovid19Data', data);
    return response.data;
  } catch (e) {
    return null
  }
}

export const saveCovidMortgageAssistance = async (data) => {
  try {
    const response = await axiosProtected.post('/Covid19/SaveMortgageAssistance', data);
    return response.data;
  } catch (e) {
    return null
  }
}
